<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="1200px">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Cấu hình Hạn đăng ký chung
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div v-show="canViewA">
          <div class="mb-3 text-h5">Cơ sở A - Cầu Giấy</div>
          <div class="config-row">
            <div class="config-section">
              <div class="mb-2 text-body-1 black--text">Khối 6</div>
              <config-section department="Cơ sở A" type="enroll" grade="Khối 6" />
              <v-divider class="my-3" />
              <config-section department="Cơ sở A" type="reserve" grade="Khối 6" />
            </div>
            <div class="config-section">
              <div class="mb-2 text-body-1 black--text">Khối 10</div>
              <config-section department="Cơ sở A" type="enroll" grade="Khối 10" />
              <v-divider class="my-3" />
              <config-section department="Cơ sở A" type="reserve" grade="Khối 10" />
            </div>
          </div>
        </div>

        <v-divider class="my-4" v-if="canViewA && canView1" />

        <div v-show="canView1">
          <div class="mb-3 text-h5">Cơ sở 1 - Tân Triều</div>
          <div class="config-row">
            <div class="config-section">
              <div class="mb-2 text-body-1 black--text">Khối 6</div>
              <config-section department="Cơ sở 1" type="enroll" grade="Khối 6" />
              <v-divider class="my-3" />
              <config-section department="Cơ sở 1" type="reserve" grade="Khối 6" />
            </div>
            <div class="config-section">
              <div class="mb-2 text-body-1 black--text">Khối 10</div>
              <config-section department="Cơ sở 1" type="enroll" grade="Khối 10" />
              <v-divider class="my-3" />
              <config-section department="Cơ sở 1" type="reserve" grade="Khối 10" />
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn outlined @click="closeDialog">Đóng</v-btn>
        <v-spacer />
        <v-btn color="admin" text @click="onViewInstruction">
          <v-icon class="mr-1">mdi-information-outline</v-icon>
          Hướng dẫn thiết lập
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import ConfigSection from './ConfigSection.vue'
import {get} from 'lodash'
export default {
  components: {ConfigSection},
  data: () => ({dialog: false}),
  computed: {
    ...mapGetters('auth', ['user']),
    userDepartment() {
      return get(this.user, 'department', '')
    },
    canViewA() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở A'
    },
    canView1() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở 1'
    },
  },
  methods: {
    ...mapActions({getEnrollDeadlines: 'enrollDeadline/fetchItems'}),
    async openDialog() {
      const query = {applyType: 'global'}
      if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1']
      else query.department_in = [this.user.department]
      await this.getEnrollDeadlines(query)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    onViewInstruction() {
      this.$dialog.confirm({
        title: 'Hướng dẫn cấu hình <strong>Hạn đăng ký</strong>',
        okText: 'Đã hiểu',
        topContent: `Để cấu hình, vui lòng chọn nút <strong>"Thiết lập"</strong> ứng với từng loại (Nhập học hoặc Dự khuyết) đối với từng khối.<br/>Sau đó vui lòng nhập<br/>1. Ngày (theo định dạng DD/MM/YYYY) <br/>2. Giờ (theo định dạng HH:mm:ss)<br/><br/>Để lưu lại thiết lập của mình, vui lòng chọn nút <strong>"Lưu"</strong>.<br/>Để huỷ bỏ thay đổi, vui lòng chọn nút <strong>"Huỷ"</strong>,`,
        midContent: `Ngay sau khi chọn lưu lại, cấu hình đối với từng vùng sẽ <strong>có hiệu lực ngay lập tức</strong>.`,
        botContent: `Khi tới hạn đã thiết lập, các hồ sơ chưa hoàn thành bước đăng ký sẽ bị chuyển thành trạng thái <strong>"Đóng đăng ký"</strong>`,
        hideCancel: true,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.config-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 0px;
}
.config-section {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
}
</style>